module.exports = __webpack_public_path__ + "img/course-editor.20ed1ba.jpg";